import React from 'react';
import styled, { keyframes } from 'styled-components/macro';

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerSvg = styled.svg<{ size?: number }>`
  width: ${({ size }) => size || 60}px;
  height: ${({ size }) => size || 60}px;
  animation: ${rotate} 1s linear infinite;
`;

const SpinnerWrapper = styled.div<{ inline?: boolean }>`
  display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};
  justify-content: center;
  align-items: center;
`;

const SpinnerContainer = styled.div<{
  center?: boolean;
  margin?: string;
  fullHeight?: boolean;
}>`
  ${({ center }) =>
    center &&
    `
    display: flex;
    justify-content: center;
    align-items: center;
  `}
  ${({ fullHeight }) =>
    fullHeight &&
    `
    height: 100%;
    width: 100%;
  `}
  ${({ margin }) => margin && `margin: ${margin};`}
`;

const CustomLoader: React.FC<{ size?: number }> = ({ size = 60 }) => (
  <SpinnerSvg width={size} height={size} size={size} viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#paint0_angular_1843_3620_clip_path)" data-figma-skip-parse="true">
        <g transform="matrix(0.0290271 0.00777778 -0.00777778 0.0290271 30.9658 31.2486)">
          <foreignObject x="-1098.38" y="-1098.38" width="2196.76" height="2196.76">
            <div
              // xmlns="http://www.w3.org/1999/xhtml"
              style={{
                background: 'conic-gradient(from 90deg,rgba(175, 213, 217, 0.35) 0deg,rgba(49, 153, 166, 1) 360deg)',
                height: '100%',
                width: '100%',
                opacity: 1,
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.08 60.6788C39.3339 65.0341 56.0408 55.3883 60.396 39.1344C64.7512 22.8806 55.1055 6.17363 38.8516 1.81842C22.5977 -2.53679 5.89079 7.10897 1.53558 23.3628C-2.81962 39.6167 6.82614 56.3236 23.08 60.6788ZM24.3942 55.7727C37.9391 59.4021 51.8615 51.3639 55.4909 37.819C59.1202 24.2742 51.0821 10.3517 37.5372 6.72236C23.9923 3.09302 10.0698 11.1312 6.44051 24.676C2.81117 38.2209 10.8493 52.1434 24.3942 55.7727Z"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.68902331590652466,&#34;g&#34;:0.83591300249099731,&#34;b&#34;:0.85193687677383423,&#34;a&#34;:0.34999999403953552},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.19256842136383057,&#34;g&#34;:0.60375100374221802,&#34;b&#34;:0.65101701021194458,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.68902331590652466,&#34;g&#34;:0.83591300249099731,&#34;b&#34;:0.85193687677383423,&#34;a&#34;:0.34999999403953552},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.19256842136383057,&#34;g&#34;:0.60375100374221802,&#34;b&#34;:0.65101701021194458,&#34;a&#34;:1.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:58.054126739501953,&#34;m01&#34;:-15.555556297302246,&#34;m02&#34;:9.7165155410766602,&#34;m10&#34;:15.555556297302246,&#34;m11&#34;:58.054126739501953,&#34;m12&#34;:-5.5562043190002441},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.9851 32.45C60.3749 32.6366 61.3502 33.9146 61.1636 35.3044C60.9901 36.5964 60.7338 37.8759 60.3965 39.135C60.0335 40.4895 58.6413 41.2933 57.2868 40.9304C55.9323 40.5674 55.1285 39.1752 55.4914 37.8207C55.7726 36.7714 55.9861 35.7052 56.1307 34.6285C56.3173 33.2387 57.5953 32.2634 58.9851 32.45Z"
        fill="#319AA6"
      />
      <defs>
        <clipPath id="paint0_angular_1843_3620_clip_path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.08 60.6788C39.3339 65.0341 56.0408 55.3883 60.396 39.1344C64.7512 22.8806 55.1055 6.17363 38.8516 1.81842C22.5977 -2.53679 5.89079 7.10897 1.53558 23.3628C-2.81962 39.6167 6.82614 56.3236 23.08 60.6788ZM24.3942 55.7727C37.9391 59.4021 51.8615 51.3639 55.4909 37.819C59.1202 24.2742 51.0821 10.3517 37.5372 6.72236C23.9923 3.09302 10.0698 11.1312 6.44051 24.676C2.81117 38.2209 10.8493 52.1434 24.3942 55.7727Z"
          />
        </clipPath>
      </defs>
    </svg>
  </SpinnerSvg>
);

interface SpinnerProps {
  size?: number;
  center?: boolean;
  inline?: boolean;
  margin?: string;
  fullHeight?: boolean;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 60,
  center = false,
  inline = false,
  margin,
  fullHeight = false,
  className,
}) => {
  const spinnerElement = (
    <SpinnerWrapper inline={inline} className={className}>
      <CustomLoader size={size} />
    </SpinnerWrapper>
  );

  if (center || fullHeight || margin) {
    return (
      <SpinnerContainer center={center} margin={margin} fullHeight={fullHeight}>
        {spinnerElement}
      </SpinnerContainer>
    );
  }

  return spinnerElement;
};

export default Spinner;
